import React from 'react';
import './Experience.css';

const Experience = () => {
    const experiences = [
        {
            title: "SOC Analyst",
            company: "WebAsha Technologies Pvt Ltd.",
            description: [
                "Delivered training on Security Operations Center (SOC) concepts including threat detection, incident response, and log analysis.",
                "Trained students on SIEM tools such as Splunk or Wazuh. Conducted hands-on labs on log monitoring, alert triage, and incident investigation. ",
                "Provided practical exposure to Windows & Linux log analysis. Designed and executed cybersecurity lab environments for real-time attack simulations. ",
                "Mentored students for cybersecurity job roles (SOC L1/L2 Analyst) and interview preparation.",
                "CGuided students on platforms like TryHackMe / Hack The Box for skill development. Delivered sessions on network security fundamentals, firewalls, IDS/IPS, and endpoint security.",

            ],
            date: "April 2026 - Present"
        },
        {
            title: "React Developer",
            company: "SOLUTION 4U",
            description: [
                "Assist in building responsive and dynamic user interfaces using React.js and related technologies.",
                "Perform unit and integration testing to ensure code quality and reliability.",
                "Use APIs to fetch and display data in the app.",
                "Help build and update webpages using React.js.",
                "Communicate with team members to complete tasks on time.",
                "Learn about React.js and other tools to improve skills."

            ],
            date: "Jan 2023 - Sept 2024"
        }
    ];

    return (
        <div className="experience-container">
            <h1 className="text-warning experience-heading">Experience</h1>
            <div className="experience-grid">
                {experiences.map((exp, index) => (
                    <div key={index} className="experience-card">
                        <p className="card-company">{exp.company}</p>
                        <h3 className="card-header">{exp.title}</h3>
                        <ul className="card-description">
                            {exp.description.map((line, index) => (
                                <li key={index}>{line}</li>
                            ))}
                        </ul>
                        <p className="card-date">{exp.date}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Experience;
